import PropTypes from 'prop-types';
import React from 'react';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import classNames from 'classnames/bind';
import GenerateBarcode from './GenerateBarcode';
import * as styles from './BarCode.css';
import cookieDetails from '../BarCode/constants';
import { couponBodyCopy } from '../../common/Constants';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';

const cx = classNames.bind(styles);

const barcodeVal = (marketingCookie, barcode) =>
    `${barcode.toString().slice(0, -5)}${cookieDetails[marketingCookie]}${barcode
        .toString()
        .slice(-3)}`;

const BarCode = ({ barcodeData, teaserTitle }) => {
    const couponInfoHtml = [];

    barcodeData?.offers?.forEach((offerItem, index) => {
        let marketingCookie = Cookies.load('marketing');
        marketingCookie = marketingCookie ? marketingCookie.split(' ').join('') : null;
        const barcode = marketingCookie
            ? barcodeVal(marketingCookie, offerItem.barCode)
            : offerItem.barCode;

        const barcodeHeadLineHTML = (
            <>
                <div className={cx('couponOffInfo', 'alignCenter')}>{offerItem.headline}</div>
                <div className={cx('couponbody', 'alignCenter')}>{offerItem.bodyCopy}</div>
                <div className={cx('showCouponDesc', 'alignCenter')}>{couponBodyCopy}</div>
            </>
        );

        barcode !== ''
            ? couponInfoHtml.push(
                  <div
                      className={cx('barcodeDetails')}
                      data-automation-id={`bar-code-${couponInfoHtml.length}`}
                  >
                      {offerItem?.conjunction ? (
                          <div
                              className={
                                  offerItem?.conjunction
                                      ? cx(
                                            'barcodeconjuction',
                                            `conjuction-${couponInfoHtml.length}`,
                                            'alignCenter'
                                        )
                                      : null
                              }
                          >
                              {offerItem?.conjunction}
                          </div>
                      ) : null}
                      {barcodeHeadLineHTML}
                      <div className={cx('barcodeWrapper')}>
                          <div className={cx('couponNumber')} data-automation-id="bar-code-number">
                              <ErrorBoundary>
                                  <GenerateBarcode id={barcode} inlineBarCode />
                              </ErrorBoundary>
                          </div>
                      </div>
                  </div>
              )
            : null;
    });
    return (
        <div className={cx('barcodeWrapper')}>
            {teaserTitle && <div className={cx('teaserTitle', 'alignCenter')}>{teaserTitle}</div>}
            {couponInfoHtml}
        </div>
    );
};

BarCode.propTypes = {
    barcodeData: PropTypes.object.isRequired,
    channelName: PropTypes.string.isRequired,
    index: PropTypes.string.isRequired,
    inlineBarCode: PropTypes.bool,
    headLineMsg: PropTypes.string,
};

BarCode.defaultProps = {
    headLineMsg: '',
    inlineBarCode: false,
};

export default BarCode;
